import type { SystemLogItem } from "../api/systemLog";
import { formatLocal, formatRelative } from "./formatting";

interface Props {
  item: SystemLogItem;
}

export function SystemLogBlock({ item }: Props) {
  const hasErrorFields = Boolean(item.error_name || item.error_message);
  const hasStack = Boolean(item.error_stack);
  const hasContext =
    item.context !== null &&
    item.context !== undefined &&
    !(typeof item.context === "object" && Object.keys(item.context as object).length === 0);

  return (
    <div className={`message-block error-block level-${item.level}`}>
      <div className="message-header">
        <span className={`level-badge ${item.level}`}>{item.level}</span>
        <span className="subsystem-badge">{item.subsystem}</span>
        <span className="header-timestamp">{formatLocal(item.ts)}</span>
        <span className="header-relative">({formatRelative(item.ts)})</span>
      </div>
      <div className="message-body">
        <div className="message-text error-message">{item.message}</div>

        {hasErrorFields && (
          <div className="error-fields">
            {item.error_name && (
              <span className="error-name">{item.error_name}</span>
            )}
            {item.error_name && item.error_message && ": "}
            {item.error_message && (
              <span className="error-detail">{item.error_message}</span>
            )}
          </div>
        )}

        {hasStack && (
          <details className="payload-dump">
            <summary>stack trace</summary>
            <pre>{item.error_stack}</pre>
          </details>
        )}

        {hasContext && (
          <details className="payload-dump">
            <summary>context</summary>
            <pre>{JSON.stringify(item.context, null, 2)}</pre>
          </details>
        )}
      </div>
    </div>
  );
}
